import { enableES5, produce } from "immer";
import { defaults, StoreActionApi } from "react-sweet-state";

// immer hack, immerable cannot be compiled from esm.js
const hasSymbol = typeof Symbol !== "undefined"
const immerable: unique symbol = hasSymbol
    ? Symbol("immer-draftable")
    : ("__$immer_draftable" as any)

declare module 'react-sweet-state' {
    // this allows setState to be called with a function instead of allowing only Partial<TState>
    // remember also that TState should be writable, as immer expects you to mutate it
    interface SetState<TState> {
        (producer: (draftState: TState) => void): void;
    }
}

enableES5(); // for IE11

defaults.mutator =
    (currentState, producer) => produce(currentState, producer);

defaults.devtools =
    true;

type ImmerMutator<State> =
    (draftState: State) => void;

function storeAction<State>(
    modifier: ImmerMutator<State>
) {
    return (store: StoreActionApi<State>) => {
        store.setState(state => modifier(state));
    }
}

export {
    ImmerMutator,
    storeAction
}

